import axios from "axios";
import React, { useEffect, useState } from "react";
import gallary from "../assets/images/gallery-1.jpg";
import { localURL } from "../utils/serverURL";
import { Eye } from "react-ionicons";
import EImageComp from "../Pages/ExperiencesPage/EImageComp";
import { Link } from "react-router-dom";

const ExperienceLatestScreenshots = ({ experienceId }) => {
  const [screenshots, setScreenshots] = useState([]);

  useEffect(() => {
    async function getAllScreenshots() {
      try {
        const response = await axios.get(
          `${localURL}experiences/getAllScreenshots?experienceId=${experienceId}`
        );
        const ss = response.data.message || [""];
        setScreenshots(ss);
      } catch (error) {
        console.error("Error fetching screenshots:", error);
        // Handle error if required
      }
    }
    getAllScreenshots();
  }, []);

  return (
    <div>
      <div className="nk-widget nk-widget-highlighted mt-4">
        <h4 className="nk-widget-title">
          <span>
            <span className="text-main-1">Latest</span> Screenshots
          </span>
        </h4>
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 bgDarkGray px-2 py-4 place-content-center place-items-center">
            {screenshots[0] &&
              screenshots?.map((url, index) => (
                <div
                  key={index}
                  className="w-[130px] h-[100px] lg:w-[160px] lg:h-[100px] relative"
                >
                  <Link to={url} target="_blank">
                    <EImageComp src={url} />
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceLatestScreenshots;
